import Vue from 'vue'
import Router from 'vue-router'

// mixen routers
import AuthRoutes from '@/router/modules/auth'
import AppRoutes from '@/router/modules/app'
import ErrorRoutes from '@/router/modules/error'
import LogsRoutes from '@/router/modules/logs'
import CompanyRoutes from '@/router/modules/company'
import ContractTypeRoutes from '@/router/modules/contractType'
import ContractRoutes from '@/router/modules/contract'
import BillRoutes from '@/router/modules/bill'
import FinancialBondTypeRoutes from '@/router/modules/financialBondType'
import FinancialBondRoutes from '@/router/modules/financialBond'
import RoleRoutes from '@/router/modules/role'
import EmployeeRoutes from '@/router/modules/employee'
import AutoEquipmentRoutes from '@/router/modules/autoEquipment'
import NotificationRoutes from '@/router/modules/notification'
import LicenseRoutes from '@/router/modules/license'
import CompanyLicenseRoutes from '@/router/modules/companyLicense'
import VacationRoutes from '@/router/modules/vacation'
import AbsenceRoutes from '@/router/modules/absence'
import RewardRoutes from '@/router/modules/reward'
import SettingRoutes from '@/router/modules/setting'
import UserRoutes from '@/router/modules/user'

var allRoutes = [];
allRoutes = allRoutes.concat(
    AuthRoutes, 
    AppRoutes, 
    ErrorRoutes,
    LogsRoutes,
    CompanyRoutes,
    ContractTypeRoutes,
    ContractRoutes,
    BillRoutes,
    FinancialBondTypeRoutes,
    FinancialBondRoutes,
    RoleRoutes,
    EmployeeRoutes,
    AutoEquipmentRoutes,
    NotificationRoutes,
    LicenseRoutes,
    CompanyLicenseRoutes,
    VacationRoutes,
    AbsenceRoutes,
    RewardRoutes,
    SettingRoutes,
    UserRoutes
)

Vue.use(Router)
export default new Router({
    mode: 'history',
    base: '/',
    fallback: true,
    routes: allRoutes
})

